import '../../../define/ui/container';
import '../../../define/ui/error-dialog';
import '../../../define/ui/dialog-backdrop';
import '../../../define/ui/dialog-popup';
import '../../../define/ui/dialog-title';
import '../../../define/ui/dialog-description';
import '../../../define/ui/dialog-close';
import '../../../define/ui/controls';
import '../../../define/ui/controls-content';
import '../../../define/ui/tooltip-group';
import '../../../define/ui/controls-group';
import '../../../define/ui/buffering-indicator';
import '../../../define/ui/play-button';
import '../../../define/ui/tooltip';
import '../../../define/ui/tooltip-label';
import '../../../define/ui/tooltip-shortcut';
import '../../../define/ui/seek-button';
import '../../../define/ui/time';
import '../../../define/ui/time-slider';
import '../../../define/ui/slider-track';
import '../../../define/ui/slider-buffer';
import '../../../define/ui/slider-fill';
import '../../../define/ui/slider-thumb';
import '../../../define/ui/slider-preview';
import '../../../define/ui/slider-value';
import '../../../define/ui/playback-rate-button';
import '../../../define/ui/menu';
import '../../../define/ui/menu-content';
import '../../../define/ui/playback-rate-radio-group';
import '../../../define/ui/menu-radio-item';
import '../../../define/ui/menu-item-indicator';
import '../../../define/ui/mute-button';
import '../../../define/ui/volume-popover';
import '../../../define/ui/volume-slider';
import '../../../define/ui/hotkey';
import '../../../define/ui/status-announcer';
import { registerIcons } from '../../../icons';
import {
  checkIcon,
  pauseIcon,
  playIcon,
  restartIcon,
  seekIcon,
  spinnerIcon,
  volumeHighIcon,
  volumeLowIcon,
  volumeOffIcon,
} from '../../../icons';

registerIcons('default', {
  check: checkIcon,
  pause: pauseIcon,
  play: playIcon,
  restart: restartIcon,
  seek: seekIcon,
  spinner: spinnerIcon,
  'volume-high': volumeHighIcon,
  'volume-low': volumeLowIcon,
  'volume-off': volumeOffIcon,
});
